import React from 'react'

function Map(props) {

  Map.defaultProps = {
    value: 250
  };

  return (
    <>
        <div className="map fix" style={{ background: "#f5f5f5" }}>
            <div className="container-flud">
                <div className="row">
                <div className="col-lg-12">
                    <iframe title="IITTP Location" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d62027.42190831132!2d79.47931416193087!3d13.675154782445166!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a4d399986289a3b%3A0x37cb3e14e1674030!2sMain%20circle%2C%20IIT%20Tirupati!5e0!3m2!1sen!2sin!4v1689848389848!5m2!1sen!2sin" 
                      width={600} height={props.value} style={{ border: 0 }} allowFullScreen="" loading="lazy" />
                    
                </div>
                </div>
            </div>
        </div>
    </>
  )
}

export default Map